
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    CHANGE_SCRIPT_GET_DEVICE_REQUEST,
    CHANGE_SCRIPT_REQUEST,
    CHANGE_SCRIPT_GET_SCRIPTS,
    CHANGE_SCRIPT_OPEN_MODAL,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { changeScriptGetDeviceResult, changeScriptResult, changeScriptGetScritpsResult } from 'Redux/actions';


function* getDevice({ payload }) {
    const { devices } = payload
    try {

        if (devices.length > 0) {
            const QUERY = `
        query searchUnits ($conditions: [UnitSearchInput], $sort: [UnitSortInput], $limit: Int, $offset: Int) {
            result: searchUnits (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    label
                    esn
                    imei
                    unitConfig {
                        pulsCustomerId
                        scriptVersion
                        configVersion
                        calampApi
                        accountId
                    }
                    deviceModel {
                        id
                        name
                        manufacturerId
                        manufacturer {
                            id
                            name
                        }
                    }
                }
                total
            }
        }
        `;

            let data = yield call(
                clientQuery,
                QUERY,
                {
                    conditions: {
                        fields: ["esn", "imei"],
                        terms: Array.isArray(devices) ? devices : [devices],
                        exact: true
                    },
                    limit: 1000,
                    offset: 0
                },
                endpoints.GRAPHQL_GENERAL,
            );

            if (data?.result) {
                yield put(changeScriptGetDeviceResult(data?.result))
            } else {
                yield put(changeScriptGetDeviceResult({ error: true }))
            }
        } else {
            yield put(changeScriptGetDeviceResult())
        }
    } catch (exc) {
        yield put(changeScriptGetDeviceResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/changeScript/redux/saga",
            "getDevice",
        )
    }
}

function* updateScript({ payload }) {
    try {
        let pulsDevices = payload.filter((item) => item.calampApi === "PULS").map((item) => ({ esn: item.esn, pulsCustomerId: item.pulsCustomerId, scriptVersion: item?.scriptVersion, configVersion: item?.configVersion }))
        let ctcDevices = payload.filter((item) => item.calampApi === "CTC" && item?.scriptId).map((item) => ({ esn: item.esn, scriptId: item?.scriptId }))
        let QUERY = `
        mutation scriptCalampDevices ($pulsDevices: [ScriptCalampPulsInput], $ctcDevices: [ScriptCalampCTCInput]) {
           result: scriptCalampDevices (pulsDevices: $pulsDevices, ctcDevices: $ctcDevices) {
                stepFunctionId
                transactionId
                transactionType
                processStartDate
            }
        }  
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                pulsDevices: pulsDevices,
                ctcDevices: ctcDevices
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (data) {
            yield put(changeScriptResult({ updateScript: true, result: data.result }))
        } else {
            yield put(changeScriptResult({ updateScript: false }))
        }

    } catch (exc) {
        yield put(changeScriptResult({ updateScript: false }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/changeScript/redux/saga",
            "updateScript",
        )
    }
}

function* getScripts({ payload }) {
    try {

        let { data } = payload;

        let QUERY = `
            query {
                
            
        `;
        for (let index = 0; index < data.length; index++) {
            let type = `
                ... on SearchCalampScriptsPuls {
                    enabled
                    scriptVersion
                    configVersion
                    name
                    description
                }
            `

            if (data[index].calampApi === "CTC") {
                type = `
                ... on SearchCalampScriptsCTC {
                    id
                    name
                    accountId
                }`
            }
            let id = data[index].calampApi === "PULS" ? data[index].pulsCustomerId : data[index].accountId

            QUERY += `
            scripts${index}: searchCalampScripts (calampApi: ${data[index].calampApi || "PULS"}, accountId: "${id}") {
                ${type}
            }
        `;
        }

        QUERY += ` 
            }
        `;

        let result = yield call(
            clientMutation,
            QUERY,
            {},
            endpoints.GRAPHQL_GENERAL,
        );

        for (let index = 0; index < data.length; index++) {
            let scripts = result[`scripts${index}`] || [];
            data[index].scripts = scripts;
        }

        yield put(changeScriptGetScritpsResult(data))


    } catch (exc) {
        yield put(changeScriptGetScritpsResult({ error: exc }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/changeScript/redux/saga",
            "getScripts",
        )
    }
}

function* watchMethods() {
    yield takeEvery(CHANGE_SCRIPT_GET_DEVICE_REQUEST, getDevice);
    yield takeEvery(CHANGE_SCRIPT_OPEN_MODAL, getDevice)
    yield takeEvery(CHANGE_SCRIPT_REQUEST, updateScript);
    yield takeEvery(CHANGE_SCRIPT_GET_SCRIPTS, getScripts);
}



export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}